import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-user',
  standalone: true,
  templateUrl: './user.component.html',
})
export class UserComponent {

}
